__turbopack_context__.v({
  "arrow": "selectInput-module-scss-module__D6e4ka__arrow",
  "selectInput": "selectInput-module-scss-module__D6e4ka__selectInput",
});
